module.exports = __webpack_public_path__ + "static/media/AVK02149.31ab287c.jpg";